import { Component, OnInit } from '@angular/core';
import { BlogHomeObject } from '../../models/blog';
import { HomeService } from '../../booking/booking-services/home.service';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls:['./blog.component.css']
})

export class BlogComponent implements OnInit {
    constructor(private _home:HomeService) { }

    blogList:BlogHomeObject[]=null;
    ngOnInit() {
        this.getHomePageBlogs();
     }

    getHomePageBlogs(){
        this._home.getallBlogPosts().subscribe((response:BlogHomeObject[])=>{
           this.blogList = response;
        })
    }
}